import { useState, useEffect } from "react";
import "../styles/Additions.css";

const Additions = () => {
  const [additionsCake, setAdditionsCake] = useState([]);
  const [additionsCatering, setAdditionsCatering] = useState([]);
  const [additionsChoc, setAdditionsChoc] = useState([]);
  const [additionsDrink, setAdditionsDrink] = useState([]);
  const [additionsFood, setAdditionsFood] = useState([]);
  const [additionsFurniture, setAdditionsFurniture] = useState([]);
  const [additionsGame, setAdditionsGame] = useState([]);
  const [additionsSignage, setAdditionsSignage] = useState([]);
  const [additionsSpeaker, setAdditionsSpeaker] = useState([]);
  const [additionsFlower, setAdditionsFlower] = useState([]);
  const [additionsBalloon, setAdditionsBalloon] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchImages = async () => {
      setLoading(true);
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/images/additions`,
        );

        if (!res.ok) {
          throw new Error(res.message || "Failed to fetch images");
        }

        const data = await res.json();

        setAdditionsCake(data.data.cake);
        setAdditionsCatering(data.data.catering);
        setAdditionsChoc(data.data.choc);
        setAdditionsDrink(data.data.drink);
        setAdditionsFood(data.data.food);
        setAdditionsFurniture(data.data.furniture);
        setAdditionsGame(data.data.game);
        setAdditionsSignage(data.data.signage);
        setAdditionsSpeaker(data.data.speaker);
        setAdditionsFlower(data.data.flower);
        setAdditionsBalloon(data.data.balloon);
      } catch (err) {
        setError(err.message || "Failed to fetch images");
      } finally {
        setLoading(false);
      }
    };
    fetchImages();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Unable to load images.</div>;
  }

  return (
    <div className="additions">
      {/* Catering Intro */}
      <section className="additions__intro--container">
        <div className="additions__intro--header">
          <h1>Additions/Enhancements</h1>
          <p>
            Enhance your luxury picnic hire with thoughtful touches and elegant
            extras to make your experience even more special
          </p>
        </div>
      </section>

      {/* Addition Options */}
      {/* Charcuterie Platter */}
      <section className="additions__options--container">
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsCatering[0]?.src}
              alt={additionsCatering[0]?.alt}
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Seasonal Charcuterie Platter for 2 people
                <strong> $70</strong>.
              </h2>
              <p>
                A curated selection of artisan cheeses and cured meats,
                accompanied by marinated vegetables, fresh seasonal fruit,
                roasted nuts, assorted condiments, crackers, and fresh bread.
              </p>
            </div>
            <div className="additions__option--details">
              <h2>
                Takeaway Pickup Service <strong>$20</strong>.
              </h2>
              <p>
                If you have a favourite takeaway on Bribie Island, we can
                collect and deliver your prearranged order to your picnic.
              </p>
            </div>
          </div>
        </div>

        {/* Box of Chocolates */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsChoc[0]?.src}
              alt={additionsChoc[0]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>Box of Chocolates</h2>
              <p>
                We can arrange your favourite chocolates to enjoy at your
                picnic. Ask for a price at time of booking.
              </p>
            </div>
          </div>
        </div>

        {/* Cake Stand */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsCake[2]?.src}
              alt={additionsCake[2]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Cake Display White <strong>$5</strong>
              </h2>
            </div>
          </div>
        </div>

        {/* Wooden Stand */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsCake[3]?.src}
              alt={additionsCake[3]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Cake Display Wooden <strong>$5</strong>
              </h2>
            </div>
          </div>
        </div>

        {/* Food Cover */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsCake[1]?.src}
              alt={additionsCake[1]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Cake Display Fillable <strong>$5</strong>
              </h2>
            </div>
          </div>
        </div>

        {/* Cake Knife & Server */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsCake[0]?.src}
              alt={additionsCake[0]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Cake Knife & Server <strong>$5</strong>
              </h2>
            </div>
          </div>
        </div>

        {/* Server - Bamboo Tray Covered */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsFood[0]?.src}
              alt={additionsFood[0]?.alt}
              className="additions__option--image"
            />
          </div>

          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Bamboo Tray with Cover <strong>$10</strong>
              </h2>
              <p>
                Bamboo Tray with collapsible Mesh Food Cover with wooden serving
                board included
              </p>
            </div>
          </div>
        </div>

        {/* Server - High Tea Stand */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsFood[1]?.src}
              alt={additionsFood[1]?.alt}
              className="additions__option--image"
            />
          </div>

          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                High Tea Stand <strong>$10</strong>
              </h2>
              <p>White platinum 3 tiered stand</p>
            </div>
          </div>
        </div>

        {/* Tea Set */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsDrink[2]?.src}
              alt={additionsDrink[2]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Tea Cup & Saucer <strong>$5 per person</strong>
              </h2>
              <p>Quality fine bone china</p>
            </div>
          </div>
        </div>

        {/* Server - 2 Tier Tray */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsFood[2]?.src}
              alt={additionsFood[2]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Iron Stand Blush Powder Coated <strong>$10</strong>
              </h2>
              <p>Medium 2 tiered</p>
            </div>
          </div>
        </div>

        {/* Server - 3 Tier Tray */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsFood[3]?.src}
              alt={additionsFood[3]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Iron Stand Blush Powder Coated <strong>$10</strong>
              </h2>
              <p>Large 3 tiered</p>
            </div>
          </div>
        </div>

        {/* Server - Wooden Board */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsFood[4]?.src}
              alt={additionsFood[4]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Serving Board Wooden <strong>$10</strong>
              </h2>
            </div>
          </div>
        </div>

        {/* Drink Dispenser */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsDrink[0]?.src}
              alt={additionsDrink[0]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Drink Dispensers <strong>$10</strong>
              </h2>
              <p>Intricate crystal cut pattern</p>
              <p>4.6 ltr beverage capacity</p>
            </div>
          </div>
        </div>

        {/* Ice Bucket */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsDrink[1]?.src}
              alt={additionsDrink[1]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Ice Buckets Including Ice <strong>$16</strong>
              </h2>
              <p>
                Keep your beverages chilled with our large gold ice filled tubs
              </p>
            </div>
          </div>
        </div>

        {/* Bluetooth Speaker */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsSpeaker[0]?.src}
              alt={additionsSpeaker[0]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Bluetooth Speaker <strong>$50</strong>
              </h2>
              <p>
                Set the mood with your favourite playlist on our premium Bose
                Sound Link portable speaker.
              </p>
            </div>
          </div>
        </div>

        {/* Fresh Floral Arrangements */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsFlower[0]?.src}
              alt={additionsFlower[0]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>Fresh Floral Arrangements</h2>
              <p>
                Delicate fresh rose petals scattered around your picnic{" "}
                <strong>$40.00</strong>
              </p>
              <p>
                Take home the beauty of your day with a seasonal bouquet, posy
                jar or roses <strong>from $65.00</strong>
              </p>
              <p>
                We're also happy to work with your preferred florist to bring
                your floral styling vision to life
              </p>
            </div>
          </div>
        </div>

        {/* Signage - Always You */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsSignage[0]?.src}
              alt={additionsSignage[0]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Signage <strong>$20</strong>
              </h2>
              <p>Add a personal touch with our stylish signage options:</p>
              <p>Custom hand written message on blackboard signage</p>
              <p>
                “It Was Always You” neon light-up table sign — perfect for
                proposals or romantic settings
              </p>
            </div>
          </div>
        </div>

        {/* Easel Stand 1 */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsSignage[5]?.src}
              alt={additionsSignage[5]?.alt}
              className="additions__option--image"
            />
          </div>

          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Easel Stand White <strong>$20</strong>
              </h2>
              <p>Add your own sign or framed photo</p>
            </div>
          </div>
        </div>

        {/* Easel Stand 2 */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsSignage[4]?.src}
              alt={additionsSignage[4]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Easel Stand Natural<strong>$20</strong>
              </h2>
              <p>Add your own sign or framed photo</p>
            </div>
          </div>
        </div>

        {/* Baby Signage */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsSignage[6]?.src}
              alt={additionsSignage[6]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Baby Shower Welcome Sign <strong>$70</strong>
              </h2>
              <p>'Oh Baby' white perspex arch shaped sign on wooden easel </p>
            </div>
          </div>
        </div>

        {/* Baby Balloons */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsBalloon[0]?.src}
              alt={additionsBalloon[0]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Baby Balloon Boxes <strong>$70</strong>
              </h2>
              <p> 4 Baby balloon boxes filled with balloons to keep</p>
            </div>
          </div>
        </div>

        {/* White Arbour Drape */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsSignage[1]?.src}
              alt={additionsSignage[1]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Macrame Hanging Decorations - Large <strong>$20</strong>
              </h2>
            </div>
          </div>
        </div>

        {/* Macrame Hanging */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsSignage[2]?.src}
              alt={additionsSignage[2]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Macrame Hanging Decorations - Medium <strong>$20</strong>
              </h2>
            </div>
          </div>
        </div>

        {/* Metal Arbour */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsSignage[7]?.src}
              alt={additionsSignage[7]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Arbour White Round Metal <strong>$70</strong>
              </h2>
              <p>2mtr diameter arbour suitable for indoor use only</p>
            </div>
          </div>
        </div>

        {/* Natural Arch Arbour */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsSignage[3]?.src}
              alt={additionsSignage[3]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Arbour Natural Arch <strong>$70</strong>
              </h2>
              <p>Arbour suitable for indoor use only</p>
            </div>
          </div>
        </div>

        {/* Games */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsGame[0]?.src}
              alt={additionsGame[0]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Lawn Games <strong>with picnic hire $70</strong>
              </h2>
              <h2>
                <strong>$200 without picnic hire</strong>
              </h2>
              <p>
                An assortment of large outdoor lawn games to keep everyone
                entertained. Includes the following games: Connect 4, Jenga,
                Nought and crosses, Bag Toss, Ring Toss scoring boards &
                instructions on how to play included
              </p>
            </div>
          </div>
        </div>

        {/* Dining Height Table */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsFurniture[0]?.src}
              alt={additionsFurniture[0]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Table Dining Height <strong>$50</strong>
              </h2>
              <p>
                Portable dining height table covered with a white fitted table
                cloth
              </p>
            </div>
          </div>
        </div>

        {/* White Market Umbrella */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsFurniture[1]?.src}
              alt={additionsFurniture[1]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Umbrella White Market <strong>$50</strong>
              </h2>
              <p>
                This stylish 3 metre white market umbrella provides portable
                shade and comes with an umbrella stand
              </p>
            </div>
          </div>
        </div>

        {/* Beige without Fringe Umbrella */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsFurniture[2]?.src}
              alt={additionsFurniture[2]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Umbrella Light Beige Luxury <strong>$50</strong>
              </h2>
              <p>
                This stylish 2 metre light beige umbrella provides portable
                shade and comes with an umbrella stand
              </p>
            </div>
          </div>
        </div>

        {/*  White Fringed Umbrella */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsFurniture[3]?.src}
              alt={additionsFurniture[3]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Umbrella White Fringed Luxury <strong>$50</strong>
              </h2>
              <p>
                This stylish 1.7 metre white fringed umbrella provides portable
                shade and comes with an umbrella stand
              </p>
            </div>
          </div>
        </div>

        {/*  Coloured Fringed Umbrella */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsFurniture[4]?.src}
              alt={additionsFurniture[4]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Umbrella Coloured Fringed Luxury <strong>$50</strong>
              </h2>
              <p>
                This stylish 1.7 metre white fringed umbrella provides portable
                shade and comes with an umbrella stand
              </p>
            </div>
          </div>
        </div>

        {/*  Black & White Striped Cabana */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsFurniture[5]?.src}
              alt={additionsFurniture[5]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Luxury Cabana White with Black Stripes <strong>$50</strong>
              </h2>
              <p>Stylish 2.5 metre cabana</p>
            </div>
          </div>
        </div>

        {/*  Dining Height Bali Chair */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsFurniture[6]?.src}
              alt={additionsFurniture[6]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Bali Chair Dining Height Includes Chair Cushion{" "}
                <strong>$50</strong>
              </h2>
              <p>Maximum weight capacity 100kg</p>
            </div>
          </div>
        </div>

        {/* Natural Low Laying Beach Chair */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsFurniture[7]?.src}
              alt={additionsFurniture[7]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Beach Chair Natural Low Lying <strong>$50</strong>
              </h2>
              <p>Adjustable recliner - Maximum weight capacity 100kg</p>
            </div>
          </div>
        </div>

        {/* White Low Laying Beach Chair */}
        <div className="additions__option--item-container">
          <div className="additions__option--image-container">
            <img
              src={additionsFurniture[8]?.src}
              alt={additionsFurniture[8]?.alt}
              className="additions__option--image"
            />
          </div>
          <div className="additions__option--details-container">
            <div className="additions__option--details">
              <h2>
                Beach Chair White Low Lying <strong>$50</strong>
              </h2>
              <p>Adjustable recliner - Maximum weight capacity 100kg</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default Additions;
